/**
 * navigation.js
 *
 * Handles toggling the navigation menu for small screens.
 */

import { getScreenHeight } from "./helper.js";
import $ from 'jquery';

export const toggleMenu = () => {
  let button = document.getElementById("toggle"),
    container = document.getElementById("site-navigation"),
    html = document.querySelector("html");

  if (button && container) {
    button.addEventListener("click", () => {
      if (button.classList.contains("open")) {
        container.classList.remove("open");
        button.classList.remove("open");
        html.classList.remove("menu-toggled");
        html.style.overflowY = "auto";
        $(container).slideUp('fast');
        return;
      }

      $(container).slideDown('fast');
      container.classList.add("open");
      button.classList.add("open");
      html.classList.add("menu-toggled");

      if (getScreenHeight() < 1260) {
        html.style.overflowY = "hidden";
      } else {
        html.style.overflowY = "auto";
      }
    });
  }
};

export const closeMenu = () => {
  let links = document.querySelectorAll(".main-navigation a"),
    nav = document.getElementById("site-navigation"),
    toggle = document.getElementById("toggle");

  links.forEach(e => {
    e.addEventListener("click", () => {
      nav.classList.remove("open");
      toggle.classList.remove("open");
    });
  });
};

export const addSticky = () => {
  let toggle = document.getElementById("toggle"),
    header = document.getElementById("masthead");

  toggle.addEventListener("click", () => {
    header.classList.add("sticky");
  });
};

export const toggleLanguages = () => {
  let list = document.querySelector(".languages ul");

  list.addEventListener("click", () => {
    if (list.classList.contains('toggled')) {
        list.classList.remove('toggled');
    } else {
        list.classList.add('toggled');
    }
  });
};
